/**
 * Creates a promise that you can resolve and reject manually.
 * @returns A resolver function, a rejector function and a promise
 */
export const resolveablePromise = <TResolveValue = void, TRejectValue = void>() => {
    let resolver: ((resolveValue: TResolveValue) => void) | undefined = undefined;
    let rejector: ((reason: TRejectValue) => void) | undefined = undefined;
    const promise = new Promise<TResolveValue>((resolve, reject) => {
        resolver = resolve;
        rejector = reject;
    });

    return {
        resolver: (resolveValue: TResolveValue) => resolver!(resolveValue),
        rejector: (reason: TRejectValue) => rejector!(reason),
        promise,
    };
};
